import React from 'react';
import "../css/styles.css";

function LoadingData() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div className="loader__spinner"></div>
        </div>
    );
}

export default LoadingData;